import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Report } from '../model/report';


@Injectable({
  providedIn: 'root'
})
export class UrlService {

  public createDownloadUrlPath(report: Report): string {
    const queryString = this.createQueryString(report);
    return `${environment.downloadUrl}?${queryString}`;
  }

  public createViewUrlPath(report: Report): string {
    const queryString = this.createQueryString(report);
    return `/#/view?${queryString}`;
  }

  public createQueryString(report: Report): string {

    const params = `bi=${this.checkForNull(report.biNumber)}`+
      `&material=${this.checkForNull(report.materialNumber)}` +
      `&mcs=${this.checkForNull(report.parentId)}` +
      `&language=${this.checkForNull(report.language)}` +
      `&supplier=${this.checkForNull(report.supplierNumber)}` +
      `&salesOrg=${this.checkForNull(report.defaultSalesOrg)}`+
      `&sbgv=${this.checkForNull(report.genVar)}` +
      `&source=${this.checkForNull(report.source)}` +
      `&version=${report.version}` +
      `&subversion=${report.subVersion}`;

    return params;
  }

  private checkForNull(field: string) {
    return field == null ? '' : field;
  }
}
